module.exports = __webpack_public_path__ + "static/media/apirest1.f1dc531a.png";